import React, {Dispatch, FC, SetStateAction} from 'react'
import {Field, Form, Formik} from 'formik'
import {Search} from '../../../../content/forms'
import {WebFormStatus} from '../../../../../../app/@types'

type SearchAndFilterProps = {
  setSearchQuery: Dispatch<SetStateAction<string>>
  allStatus: WebFormStatus[]
  categories: {name: string}[]
  setStatusRow: (status: string) => void
  setCategoriesRow: (category: string) => void
  formType: 'wp' | 'wf'
}

const initialWebFormValues = {
  status: 'all',
  category: 'all',
}

const SearchAndFilter: FC<SearchAndFilterProps> = ({
                                                     setSearchQuery,
                                                     allStatus,
                                                     categories,
                                                     setStatusRow,
                                                     setCategoriesRow,
                                                     formType,
                                                   }) => {
  return (
    <div className="row mb-7 d-flex justify-content-between align-items-center">
      <div className="col-12 col-sm-5 col-xl-4">
        <Search setSearchInput={setSearchQuery} />
      </div>
      <div className="col-12 col-sm-7 col-xl-5 mt-5 mt-sm-0">
        <Formik initialValues={initialWebFormValues} onSubmit={() => {
        }}>
          {({values}) => (
            <Form>
              <div className="row d-flex justify-content-end align-items-center">
                <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                  <div className="d-flex align-items-center fw-bold">
                    <label htmlFor="status" className="text-gray-400 fs-8 fs-sm-7 me-2 me-sm-6">
                      Statut
                    </label>
                    <Field
                      className="form-select form-select-sm form-select-solid"
                      aria-label="Select example"
                      as="select"
                      name="status"
                      id="status"
                      onClick={() => setStatusRow(values.status)}
                    >
                      <option value="all">Tous</option>
                      {allStatus.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.name}
                        </option>
                      ))}
                    </Field>
                  </div>
                </div>
                {
                  formType !== 'wp' && (
                    <div className="col-12 col-sm-6">
                      <div className="d-flex align-items-center">
                        <label htmlFor="category" className="text-gray-400 fs-8 fs-sm-7 me-2 me-sm-">
                          Catégories
                        </label>
                        <Field
                          className="form-select form-select-sm form-select-solid"
                          aria-label="Select example"
                          as="select"
                          name="category"
                          id="category"
                          onClick={() => setCategoriesRow(values.category)}
                        >
                          <option value="all">Tous</option>
                          {categories.map((category, categoryIndex) => (
                            <option value={`${category.name}`} key={categoryIndex}>
                              {category.name}
                            </option>
                          ))}
                        </Field>
                      </div>
                    </div>
                  )
                }
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export {SearchAndFilter}